import { useEffect } from 'react';
const isUATEnable = process.env.REACT_APP_UAT_FLAG === 'true';
const DuxWidget = () => {
  useEffect(() => {
    const duxWidgetUserId = localStorage.getItem('duxwidgetuserid');

    if (duxWidgetUserId) {
      // Set a delay of 5 seconds (5000ms) before loading the script
      const delay = 3000;
      const timeout = setTimeout(() => {
        const script = document.createElement('script');
        script.src = isUATEnable ?'https://dux.uatdemo.dev/api/widget?timer=off&position=bc':'https://web.dux.ws/api/widget?timer=off&position=bc';
        script.async = true;
        document.head.appendChild(script);

        // Cleanup function to remove the script when the component unmounts
        return () => {
          if (script.parentNode) {
            document.head.removeChild(script);
          }
        };
      }, delay);

      // Cleanup function to clear the timeout when the component unmounts
      return () => {
        clearTimeout(timeout);
      };
    }
  }, []); // Empty dependency array ensures this runs only once

  return null;
};

export default DuxWidget;
